import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "M10 0c5.5249 0 10 4.47514 10 10 0 5.5249-4.4751 10-10 10-5.52486 0-10-4.4751-10-10C0 4.47514 4.47514 0 10 0Zm3.7127 8.83978-.8729-.88398-2.221 2.2099V3.84531H9.38122v6.32039l-2.23205-2.232-.88398.87293L10 12.5525l3.7127-3.71272Zm.6188 3.71272v1.2376H5.63536v-1.2376H4.38674v2.4862H15.5691v-2.4862h-1.2376Z" }) });
export {
  p as Export
};
//# sourceMappingURL=Export.js.map
